<template>

  <section class="invoice-preview-wrapper">
     <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>

        </b-card>
      </b-col>

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="invoiceData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-invoice-list'}"
        >
          Invoice List
        </b-link>
        for other invoices.
      </div>
    </b-alert>

    <b-row
      v-if="invoiceData"
      class="invoice-preview"      
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="12"
        md="12"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
        <div class="factura-header">

        
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0 ">

            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                    <img :src="invoiceData.empresa.image" style="max-width: 200px; margin-top: 20px" alt="">
                </div>                
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-0 mt-2" style="position: absolute; top:10px; right:20px">
                <h4 class="invoice-title">
                  Factura:
                  <span class="invoice-number">{{ invoiceData.codigo }}</span>
                </h4>
                <div class="invoice-date-wrapper2">
                  <p class="invoice-date-title2">
                   Fecha: {{ invoiceData.fecha }}
                  </p>
                </div>               
              </div>
            </div>
          </b-card-body>



          <!-- Invoice Client & Payment Details -->
          <b-card-body
            v-if="invoiceData.cliente"
            class="invoice-padding pt-0"
          >
            <b-row class="invoice-spacing">

              <!-- Col: Invoice To -->
              <b-col
                cols="12"
                xl="6"
                class="p-0"
              >
               <b-card-text class="mb-25">
                <h6 class="mb-2">
                  <b></b>
                </h6>
                <br>
                    <b>{{invoiceData.empresa.nombre}}</b>
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{invoiceData.empresa.direccion}}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{invoiceData.empresa.direccion2}}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{invoiceData.empresa.direccion3}}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{invoiceData.empresa.cif}}
                  </b-card-text>
               
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <div>
                  <h6 class="mb-2">
                    <b>Cliente:</b>
                  </h6>
                  <h6 class="mb-25">
                    <b>{{ invoiceData.cliente.nombre }}</b>
                  </h6>
                  <b-card-text class="mb-25">
                    {{ invoiceData.cliente.tlf }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ invoiceData.cliente.direccion }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ invoiceData.cliente.cp }}, {{ invoiceData.cliente.provincia }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ invoiceData.cliente.ciudad }}, {{ invoiceData.cliente.pais }}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{ invoiceData.cliente.email }}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{ invoiceData.cliente.cif }}
                  </b-card-text>                  
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </div>

        <main>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            :items="invoiceData.items"
            :fields="columnas"
            class="tabla-factura-preview"            
            :class="classMargenTablaPreview"   
          >           
            <template #head(precio)="data">
              <div class="align-right">
                <span>{{ data.label.toUpperCase() }}</span>
              </div>
            </template>

            <template #head(cantidad)="data">
              <div class="align-right">
                <span>{{ data.label.toUpperCase() }}</span>
              </div>
            </template>

             <template #head(total)="data">
              <div class="align-right">
                <span>{{ data.label.toUpperCase() }}</span>
              </div>
            </template>

            <template #cell(descripcion)="data">
              <p style="white-space: pre-line; margin: 0;">
                {{ data.item.descripcion }}
              </p>
            </template>
            <template #cell(precio)="data">
              <p style="white-space: pre-line; margin: 0; text-align: right;">
                {{ data.item.precio }}
              </p>
            </template>
            <template #cell(cantidad)="data">
              <p style="white-space: pre-line; margin: 0; text-align: right;"> {{ data.item.cantidad }} </p>
            </template>
            <template #cell(total)="data">
              <p style="white-space: pre-line; margin: 0; text-align: right;">
                {{ data.item.total }}
              </p>
            </template>
            
          </b-table-lite>

          <div class="container-footer" :class="invoiceData.classbanco">
            <div class="flex-container">
              <div class="left">  <div>
                    <h6 class="mb-2">
                      <b>Detalles del pago:</b>
                    </h6>
                    <table>
                      <tbody v-if="invoiceData.empresa.id == 2">
                        <tr>
                          <td class="pr-1">
                            Banco:
                          </td>
                          <td>Sabadell </td>
                        </tr>                     
                        <tr>
                          <td class="pr-1">
                            IBAN:
                          </td>
                          <td>ES89 0081 5107 1700 0161 7268</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            SWIFT code:
                          </td>
                          <td>BSABESBBXXX</td>
                        </tr>
                      </tbody>
                      <tbody v-if="invoiceData.empresa.id == 1">                     
                        <tr>
                          <td class="pr-1">
                            Bank:
                          </td>
                          <td>HSBC </td>
                        </tr>     
                        <tr>
                          <td class="pr-1">
                            Short Code:
                          </td>
                          <td>40-02-26 </td>
                        </tr>                  
                        <tr>
                          <td class="pr-1">
                            Bank Account:
                          </td>
                          <td>02770253</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            IBAN:
                          </td>
                          <td>GB90 HBUK 4002 2602 7702 53</td>
                        </tr>
                      </tbody>
                    </table>
                  </div></div>
              <div class="right">
                <div class="invoice-total-wrapper">
                    <div class="invoice-total-item" v-if="invoiceData.descuentototal != 0 || invoiceData.retencion != 0 || invoiceData.iva>0 || invoiceData.shipping != 0">
                      <p class="invoice-total-title">
                        Subtotal:
                      </p>
                      <p class="invoice-total-amount">
                        {{invoiceData.subtotal}}
                      </p>
                    </div>
                    <div class="invoice-total-item" v-if="invoiceData.descuentototal != 0">
                      <p class="invoice-total-title">
                        Descuento:
                      </p>
                      <p class="invoice-total-amount">
                        -{{invoiceData.descuentototal}}
                      </p>
                    </div>
                    <div class="invoice-total-item" v-if="invoiceData.retencion != 0">
                      <p class="invoice-total-title">
                        Retencion {{invoiceData.retencion}}%:
                      </p>
                      <p class="invoice-total-amount">
                        -{{invoiceData.retenciontotal}}
                      </p>
                    </div>
                    <div class="invoice-total-item" v-if="invoiceData.iva>0">
                      <p class="invoice-total-title">
                        Iva {{invoiceData.iva}}%:
                      </p>
                      <p class="invoice-total-amount">
                        {{invoiceData.ivatotal}}
                      </p>
                    </div>
                    <div class="invoice-total-item" v-if="invoiceData.shipping != 0">
                      <p class="invoice-total-title">
                        Shipping:
                      </p>
                      <p class="invoice-total-amount">
                        {{invoiceData.shipping}}
                      </p>
                    </div>
                    <hr class="my-50">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Total:
                      </p>
                      <p class="invoice-total-amount">
                        {{invoiceData.total}}
                      </p>
                    </div>
                  </div></div>
            </div>
          </div>

          <!-- Spacer -->
          <hr class="invoice-spacing" v-if="invoiceData.notas != null && invoiceData.notas.length > 0">

          <!-- Note -->
          <b-card-body class="invoice-padding pt-0" v-if="invoiceData.notas != null && invoiceData.notas.length > 0">
            <span class="font-weight-bold">Notas: </span>
            <span>{{invoiceData.notas}}</span>
          </b-card-body>

          
        </main>
        </b-card>
      </b-col>

    
    </b-row>

      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>
        </b-card>
      </b-col>

  </section>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle,
} from 'bootstrap-vue'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import axios from '@axios'
//import invoiceStoreModule from '../invoiceStoreModule'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    Logo,
  },
  data() {
    return {
      iban: '',    
      classMargenTablaPreview: "tabla-margen-0"  
    }
  },
  methods: {
  },
  setup() {
    let invoiceData = ref(null)
    const paymentDetails = ref({})
    let columnas = [];


    /*const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })*/
    function ponerMoneda(total, moneda){
      if(moneda == "€")
        return total +''+ moneda
      else
        return moneda +''+ total;      
    }

    //columnas = ['descripcion', 'precio', 'cantidad', 'total'];
    //      thStyle: { width: "10%" },

    columnas = [
      {
        key: "descripcion",
        label: "Descripcion",
        thStyle: { width: "90%", textAlign: 'left'},
      },
      {
        key: "precio",
        label: "precio",
        thStyle: { width: "10%"},
      }
     ];

    axios
      .get("/finanzas/factura/"+router.currentRoute.params.id)
      .then(response => {
          return response.data;
      })
      .then(res => {
        invoiceData.value = res;

        let addDescuento = false;
        let tieneCantidad = false;

        invoiceData.value.items.forEach(item => {
          item.precio = ponerMoneda(item.precio.toFixed(2),invoiceData.value.empresa.moneda)
          item.total = ponerMoneda(item.total.toFixed(2),invoiceData.value.empresa.moneda)

          if(item.descuento != 0)
          {
            addDescuento = true;
          }

          if(item.cantidad > 0)
            tieneCantidad = true;
          
        });

        if(tieneCantidad){
          columnas.push(          
          {
            key: "cantidad",
            label: "UDS",
            thStyle: { width: "10%" },
          },
          {
            key: "total",
            label: "total",
            thStyle: { width: "10%" },
          })
        }
      
        if(addDescuento && tieneCantidad)
        {
          columnas.splice(3, 0, {
            key: "descuento",
            label: "Descuento",
            thStyle: { width: "10%" },
          });
        } else if(addDescuento && !tieneCantidad){
          columnas.push(          
          {
            key: "descuento",
            label: "Descuento",
            thStyle: { width: "10%" },
          },
          {
            key: "total",
            label: "total",
            thStyle: { width: "10%" },
          })
        }

        invoiceData.value.total = ponerMoneda(invoiceData.value.total.toFixed(2),invoiceData.value.empresa.moneda);

        if(invoiceData.value.items.length % 29 == 0){
          invoiceData.value.classbanco = "div-banco-separacion";
        }
        else{
          invoiceData.value.classbanco = "";
        }        

      });

    const printInvoice = () => {

      let resModulo = this.invoiceData.items.length%27;

      if(resModulo == 0)//27
        this.classMargenTablaPreview = 'tabla-margen-25';
      else if(resModulo == 26)
        this.classMargenTablaPreview = 'tabla-margen-35';
      else if(resModulo == 25)
        this.classMargenTablaPreview = 'tabla-margen-70';
      else if(resModulo == 24)
        this.classMargenTablaPreview = 'tabla-margen-115';
      else if(resModulo == 23)
        this.classMargenTablaPreview = 'tabla-margen-n20';
      else if(resModulo <= 22)
        this.classMargenTablaPreview = 'tabla-margen-0';

      window.print()
    }

    return {
      invoiceData,
      paymentDetails,
      printInvoice,
      columnas
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">

.flex-container {
  display: flex;
}

.container-footer {
    margin-top: 40px;
  }

.left {
  margin-left: 30px;
  flex: 1;
}

.right {
  margin-left: auto;
  margin-right: 28px;
}

.invoice-total-amount{
  margin-left: 10px;
}

/*@page {
  margin: 0;
}*/

.align-right {
      text-align: right !important;
    }

    .tabla-margen-0{
    margin-top: 0px !important;
  }

  .tabla-margen-25{
    margin-top: 25px !important;
  }

  .tabla-margen-35{
    margin-top: 35px !important;
  }

  .tabla-margen-70{
    margin-top: 70px !important;
  }

  .tabla-margen-115{
    margin-top: 915px !important;
  }

  .tabla-margen-n20{
    margin-top: -20px;
  }

@media print {

   .align-right {
      text-align: right !important;
    }

   .tabla-factura-preview thead tr th{
    background-color: transparent;
    height: 350px;
    position: relative;
  }

  .tabla-factura-preview thead tr th div{
    position: absolute;
    bottom: 0;
  }

  .invoice-preview-card{
    top: 0px !important;
  }

  // Global Styles
 /* body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }*/

  .invoice-preview-wrapper{
    margin-top: -80px !important;
  }

  /*.div-banco-2{
      margin-top: -100px !important;
  }

  .div-banco-3{
      margin-top: -120px !important;
  }

  .div-banco-4{
      margin-top: -140px !important;
  }

  .div-banco-5{
      margin-top: -160px !important;
  }*/

  /*@page {
    margin-top: 50px; 
  }*/


  .factura-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 350px;
    padding: 10px;
    font-size: 16px;
    z-index: 9999;
  }

  /*.tabla-factura{
    margin-top: 320px !important;
  }*/

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

   

    // Action Right Col
    .invoice-actions {
      display: none;
    }

  .tabla-factura-preview tr:nth-child(even) td {
       background-color: #f1f1f1 !important;
        -webkit-print-color-adjust: exact;
        color: black;
   }

   .tabla-factura-preview tr:nth-child(odd) td {
        color: black;
   }
    
  }
}
</style>